import {
  AmlTraceHistoryItem,
  AmlTraceListResponse,
  TracerCurrenciesResponse,
} from '@/api';
import { AmlTraceHistoryData, AmlTraceHistoryItemData } from '../models';
import { ChainsEnum, ChainsDictionary } from '@/config';

const detectAsset = (item: AmlTraceHistoryItem) => {
  if (item?.tokenDetails?.code) {
    return item.tokenDetails.code;
  }

  if (item?.info?.caseMeta?.asset_symbol) {
    return item.info.caseMeta.asset_symbol;
  }

  return item?.asset && ChainsDictionary[item.asset]
    ? ChainsDictionary[item.asset].symbol
    : item?.asset;
};

const mapTraceHistoryItem = (item: AmlTraceHistoryItem) => {
  return <AmlTraceHistoryItemData>{
    uuid: item.uid,
    address: item.address,
    tx: item.tx,
    asset: item.asset,
    flow: item.flow,
    network: item.network,
    cost: item.cost,
    status: item.status,
    timestamp: item.timestamp,
    tokenDetails: item.tokenDetails,
    displayAsset: detectAsset(item),
    tokenId: item.tokenId,
    type: item._type,
    info: item.info,
  };
};

const traceHistory = (response: AmlTraceListResponse): AmlTraceHistoryData => {
  const { data } = response;

  return {
    result: data.result,
    pageLimit: data.pageLimit,
    totalCount: data.totalCount,
    items: data.data.map(mapTraceHistoryItem),
  };
};

const tracerCurrencies = (response: TracerCurrenciesResponse) => {
  const { data } = response;

  return data.currencies.map(
    (currency) => currency.toUpperCase() as ChainsEnum,
  );
};

export { traceHistory, tracerCurrencies };
